/**
 * Shoe Sizing Advice for TennisHQ
 * Displays single-line sizing advice for tennis shoes
 */
(function() {
  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) {
    return;
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 100); // Slight delay to ensure page is fully rendered
  }
  
  // Main initialization function
  function initialize() {
    // Check if this is a shoe product
    if (isShoeProduct()) {
      // Get the brand name
      const brandName = getBrandName();
      
      // Find the concise fit information from the "SHOE SIZE LENGTH FIT" section
      const fitType = extractFitType();
      
      if (fitType && brandName) {
        // Format the advice text with brand name and fit type
        const sizeAdvice = `${brandName} Shoes are - ${fitType} fitting.`;
        
        // Display the size information before the quantity box
        displaySizeAdvice(sizeAdvice);
      }
    }
  }
  
  // Check if this is a shoe product - adapted for tennis shoes
  function isShoeProduct() {
    const url = window.location.pathname.toLowerCase();
    const title = document.title.toLowerCase();
    const breadcrumbs = document.querySelectorAll('.breadcrumbs__link, .breadcrumb__link');
    const productType = document.querySelector('.product-meta__type, .product__type')?.textContent.toLowerCase() || '';
    
    // Tennis-specific shoe keywords
    const shoeKeywords = ['shoe', 'footwear', 'trainer', 'court shoe', 'tennis shoe'];
    
    // Check URL and title
    for (const keyword of shoeKeywords) {
      if (url.includes(keyword) || title.includes(keyword) || productType.includes(keyword)) {
        return true;
      }
    }
    
    // Check breadcrumbs
    for (let i = 0; i < breadcrumbs.length; i++) {
      const text = breadcrumbs[i].textContent.toLowerCase();
      for (const keyword of shoeKeywords) {
        if (text.includes(keyword)) {
          return true;
        }
      }
    }
    
    // Check URL for collections that are likely shoe collections
    if (url.includes('/collections/') && 
        (url.includes('tennis-shoes') || url.includes('court-shoes'))) {
      return true;
    }
    
    return false;
  }
  
  // Get the brand name from the product page
  function getBrandName() {
    // Try different selectors to find the brand
    const vendorElement = document.querySelector('.product-meta__vendor, .product__vendor');
    if (vendorElement) {
      return vendorElement.textContent.trim();
    }
    
    // Try to extract from title
    const title = document.querySelector('h1.product__title, .product-title')?.textContent || document.title;
    if (title) {
      // Check for common tennis shoe brands
      const commonBrands = ['Adidas', 'Nike', 'Asics', 'New Balance', 'K-Swiss', 'Babolat', 'Wilson', 'Head', 'Yonex'];
      for (const brand of commonBrands) {
        if (title.includes(brand)) {
          return brand;
        }
      }
      
      // Extract the first word which is often the brand
      const firstWord = title.split(' ')[0];
      if (firstWord && firstWord.length > 2) {
        return firstWord.trim();
      }
    }
    
    // Fallback: extract from URL
    const url = window.location.pathname;
    const urlParts = url.split('/');
    const productSlug = urlParts[urlParts.length - 1];
    const brandFromUrl = productSlug.split('-')[0];
    
    if (brandFromUrl && brandFromUrl.length > 2) {
      return brandFromUrl.charAt(0).toUpperCase() + brandFromUrl.slice(1);
    }
    
    return "These";
  }
  
  // Extract ONLY the fit type (e.g., "True to Size") from the SHOE SIZE LENGTH FIT section
  function extractFitType() {
    // Find all potential description elements
    const descriptionElements = [
      ...document.querySelectorAll('.product__description'),
      ...document.querySelectorAll('.product-description'),
      ...document.querySelectorAll('.product-tab__content'),
      ...document.querySelectorAll('.product__accordion'),
      ...document.querySelectorAll('p')
    ];
    
    // Method 1: Look for elements containing "SHOE SIZE LENGTH FIT"
    for (const element of descriptionElements) {
      const textContent = element.textContent || '';
      
      if (textContent.includes('SHOE SIZE LENGTH FIT') || 
          textContent.includes('Shoe Size Length Fit') ||
          textContent.includes('shoe size length fit')) {
        
        // Extract the part that comes after "SHOE SIZE LENGTH FIT"
        const parts = textContent.split(/SHOE SIZE LENGTH FIT|Shoe Size Length Fit|shoe size length fit/i);
        
        if (parts.length > 1) {
          // Get the content after the heading
          let fitText = parts[1].trim();
          
          // Extract just the fit type (like "True to Size")
          const fitMatch = fitText.match(/(True to Size|Half size small|Half size large|Small fitting|Large fitting|Normal fitting|Standard fitting|Regular fitting)/i);
          
          if (fitMatch) {
            return fitMatch[0].trim();
          }
          
          // If no standard phrases found, try to extract the first short phrase
          const shortPhrase = fitText.split(/[.,;:\n]/)[0].trim();
          if (shortPhrase && shortPhrase.length < 30) {
            return shortPhrase;
          }
        }
      }
    }
    
    // Method 2: Look for specific fit indicators in the product description
    const fullText = descriptionElements.map(el => el.textContent || '').join(' ');
    
    // Check for specific phrases indicating fit
    const fitPhrases = [
      { regex: /true\s+to\s+size/i, value: "True to Size" },
      { regex: /half\s+size\s+small/i, value: "Half size small" },
      { regex: /half\s+a\s+size\s+small/i, value: "Half size small" },
      { regex: /1\/2\s+size\s+small/i, value: "Half size small" },
      { regex: /runs\s+small/i, value: "Small fitting" },
      { regex: /small\s+fitting/i, value: "Small fitting" },
      { regex: /narrow\s+fit/i, value: "Narrow fitting" },
      { regex: /wide\s+fit/i, value: "Wide fitting" }
    ];
    
    for (const phrase of fitPhrases) {
      if (phrase.regex.test(fullText)) {
        return phrase.value;
      }
    }
    
    // Brand-specific defaults
    if (isAdidas()) {
      return "True to Size";
    } else if (isAsics()) {
      return "True to Size";
    } else if (isNike()) {
      return "Small fitting";
    } else if (isBabolat()) {
      return "True to Size";
    } else if (isYonexShoe()) {
      return "1/2 a size small";
    }
    
    // Default if no specific fit info is found
    return "True to Size";
  }
  
  // Check if this is a Yonex shoe
  function isYonexShoe() {
    const title = document.title.toLowerCase();
    const url = window.location.pathname.toLowerCase();
    const productVendor = document.querySelector('.product-meta__vendor, .product__vendor')?.textContent.toLowerCase() || '';
    
    return title.includes('yonex') || url.includes('yonex') || productVendor.includes('yonex');
  }
  
  // Check if this is an Adidas shoe
  function isAdidas() {
    const title = document.title.toLowerCase();
    const url = window.location.pathname.toLowerCase();
    const productVendor = document.querySelector('.product-meta__vendor, .product__vendor')?.textContent.toLowerCase() || '';
    
    return title.includes('adidas') || url.includes('adidas') || productVendor.includes('adidas');
  }
  
  // Check if this is an Asics shoe
  function isAsics() {
    const title = document.title.toLowerCase();
    const url = window.location.pathname.toLowerCase();
    const productVendor = document.querySelector('.product-meta__vendor, .product__vendor')?.textContent.toLowerCase() || '';
    
    return title.includes('asics') || url.includes('asics') || productVendor.includes('asics');
  }
  
  // Check if this is a Nike shoe
  function isNike() {
    const title = document.title.toLowerCase();
    const url = window.location.pathname.toLowerCase();
    const productVendor = document.querySelector('.product-meta__vendor, .product__vendor')?.textContent.toLowerCase() || '';
    
    return title.includes('nike') || url.includes('nike') || productVendor.includes('nike');
  }
  
  // Check if this is a Babolat shoe
  function isBabolat() {
    const title = document.title.toLowerCase();
    const url = window.location.pathname.toLowerCase();
    const productVendor = document.querySelector('.product-meta__vendor, .product__vendor')?.textContent.toLowerCase() || '';
    
    return title.includes('babolat') || url.includes('babolat') || productVendor.includes('babolat');
  }
  
  // Display the size advice correctly positioned before the quantity box
  function displaySizeAdvice(sizeInfo) {
    // First, find and analyze the "Order within" text to match its style
    const orderWithinText = document.querySelector('.product__inventory, .inventory');
    let baseFontSize = '13px';
    let fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
    let textColor = '#BE163D';
    
    // Try to match the "Order within" text style if it exists
    if (orderWithinText) {
      const computedStyle = window.getComputedStyle(orderWithinText);
      baseFontSize = computedStyle.fontSize;
      fontFamily = computedStyle.fontFamily;
      // Keep the color red for visibility
    }
    
    // Calculate the font size: reduce by 30.7% from original (69.3% of original size)
    const adjustedFontSize = calculateAdjustedFontSize(baseFontSize, 0.693);
    
    // Create the advice element
    const adviceElement = document.createElement('div');
    adviceElement.className = 'shoe-sizing-advice';
    
    // Set the HTML with just the text (no icon)
    adviceElement.innerHTML = `
      <div class="shoe-sizing-advice-content">
        <span class="shoe-sizing-advice-text"><strong>Sizing Advice:</strong> ${sizeInfo}</span>
      </div>
    `;
    
    // Add the styles with adjusted font size
    const styles = document.createElement('style');
    styles.textContent = `
      .shoe-sizing-advice {
        color: ${textColor};
        margin-bottom: 8px;
        margin-top: 8px;
        padding: 4px 8px;
        background-color: #ffeeee;
        border-radius: 4px;
        font-size: ${adjustedFontSize};
        font-family: ${fontFamily};
        line-height: 1.2;
        height: auto;
        overflow: visible;
      }
      
      .shoe-sizing-advice-content {
        display: flex;
        align-items: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      
      .shoe-sizing-advice-text {
        flex-grow: 1;
        display: inline-block;
        vertical-align: middle;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      
      @media (max-width: 768px) {
        .shoe-sizing-advice {
          font-size: ${adjustedFontSize};
          padding: 3px 6px;
        }
      }
    `;
    document.head.appendChild(styles);
    
    // Try to find the correct insertion point - BEFORE the quantity box
    const quantitySelector = document.querySelector('.product-form__quantity, .quantity-selector, input[name="quantity"], .product-form__input--quantity');
    
    if (quantitySelector) {
      // Look for the parent container of the quantity selector
      let container = quantitySelector;
      let depth = 0;
      
      // Go up the DOM tree to find a good container
      while (depth < 4 && container.parentElement) {
        container = container.parentElement;
        depth++;
        
        // If we found a good container, insert before it
        if (container.className.includes('quantity') || 
            container.className.includes('product-form__input') ||
            container.tagName === 'DIV') {
          container.parentElement.insertBefore(adviceElement, container);
          return;
        }
      }
      
      // If we couldn't find a good container, just insert before the quantity selector itself
      quantitySelector.parentElement.insertBefore(adviceElement, quantitySelector);
      return;
    }
    
    // Fallback: try to find the add to cart button and insert before it
    const addToCartButton = document.querySelector('.product-form__submit, button[name="add"]');
    if (addToCartButton) {
      const buttonContainer = addToCartButton.parentElement;
      buttonContainer.insertBefore(adviceElement, addToCartButton);
    }
  }
  
  // Helper function to adjust font size
  function calculateAdjustedFontSize(originalSize, factor) {
    // Extract the numeric value and unit from the font size
    const match = originalSize.match(/^([\d.]+)(\D+)$/);
    
    if (!match) {
      // Fallback if we can't parse the font size
      return '9px'; // 69.3% of 13px
    }
    
    const [, value, unit] = match;
    const adjustedValue = parseFloat(value) * factor;
    
    return `${adjustedValue.toFixed(1)}${unit}`;
  }
})();